module.exports = __webpack_public_path__ + "fonts/webdatarocks-icons.1d4f5e08.ttf";